import { createApp } from 'vue'
import App from './App.vue'
import "@/assets/libs/@mdi/font/css/materialdesignicons.min.css";
import '@/assets/libs/@iconscout/unicons/css/line.css'
import router from './router';
import './plugins/axios'
import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query'
import { createPinia } from 'pinia';
import { createHead } from '@unhead/vue/client'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import '@/assets/scss/tailwind.scss'

const vuetify = createVuetify({
    components,
    directives,
  })

const queryClient = new QueryClient();
const pinia = createPinia();
const head = createHead()

const app = createApp(App)
app.use(router);
app.use(VueQueryPlugin, { queryClient })
app.use(pinia)
app.use(head)
app.use(vuetify)
app.mount('#app')